import type { FC, ReactNode } from 'react'

import { ShieldCheck } from 'lucide-react'

import { cn } from '@/lib/utils'
import { brand } from '@/constants/brand'
import { formatDate } from '@/lib/format'

interface EditorialBylineProps {
    updatedAt: string
    publishedAt?: string
    readMinutes?: number
    className?: string
}

// Byline is the organisation, never an individual. WellPath Fusion publishes
// general wellness education with no named clinical reviewer, so a personal
// byline with credentials would be a trust signal we have not earned.
export const EditorialByline: FC<EditorialBylineProps> = ({
    updatedAt,
    publishedAt,
    readMinutes,
    className
}): ReactNode => {
    return (
        <div className={cn('flex items-center gap-3 border-y border-border py-5', className)}>
            <span className='flex size-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary'>
                <ShieldCheck className='size-5' />
            </span>

            <div className='flex flex-col text-sm'>
                <span className='font-medium text-foreground'>Written by {brand.name}</span>
                <span className='text-muted-foreground'>
                    Last updated{' '}
                    <time dateTime={updatedAt}>{formatDate(updatedAt)}</time>
                    {publishedAt && publishedAt !== updatedAt && (
                        <>
                            {' · Published '}
                            <time dateTime={publishedAt}>{formatDate(publishedAt)}</time>
                        </>
                    )}
                    {typeof readMinutes === 'number' && ` · ${readMinutes} min read`}
                </span>
            </div>
        </div>
    )
}
